<div>
  <mat-paginator #Paginator
                  (page)="pageEvent($event)"
                  [pageIndex]= 'pageIndex'
                  [length]="totalCount"
                  [pageSize]="20"
                  aria-label="Select page">
            </mat-paginator>
</div>
